export type IcmsIconsId =
  | 'warning'
  | 'vm'
  | 'view'
  | 'video'
  | 'unlink'
  | 'undo'
  | 'underline'
  | 'time'
  | 'tick'
  | 'tag'
  | 'style'
  | 'strikethrough'
  | 'share'
  | 'settings'
  | 'search'
  | 'save'
  | 'revert'
  | 'restore'
  | 'refresh'
  | 'redo'
  | 'publish'
  | 'preview-image'
  | 'plus'
  | 'pin'
  | 'pin-fill'
  | 'pen'
  | 'paste'
  | 'pages'
  | 'p'
  | 'new-folder'
  | 'more-vert'
  | 'minus'
  | 'menu'
  | 'lock'
  | 'list'
  | 'list-numbered'
  | 'list-checked'
  | 'link'
  | 'launch'
  | 'italic'
  | 'info'
  | 'images'
  | 'image-search'
  | 'home'
  | 'hide'
  | 'h6'
  | 'h5'
  | 'h4'
  | 'h3'
  | 'h2'
  | 'h1'
  | 'folder'
  | 'find-in-page'
  | 'filter-list'
  | 'file-upload'
  | 'expand'
  | 'edit'
  | 'duplicate'
  | 'drag'
  | 'drag-1'
  | 'draft'
  | 'device-x'
  | 'device-s'
  | 'device-m'
  | 'device-l'
  | 'design'
  | 'content'
  | 'content-copy'
  | 'config'
  | 'compress'
  | 'commnd-centre'
  | 'close'
  | 'clear-format'
  | 'chevron-up'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'calendar'
  | 'bold'
  | 'bind-mirror'
  | 'bin'
  | 'audio'
  | 'arrow-up'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-down'
  | 'alternate'
  | 'alternate-link'
  | 'add-layout'
  | 'add-at-bottom'
  | 'PDF';

export type IcmsIconsKey =
  | 'Warning'
  | 'Vm'
  | 'View'
  | 'Video'
  | 'Unlink'
  | 'Undo'
  | 'Underline'
  | 'Time'
  | 'Tick'
  | 'Tag'
  | 'Style'
  | 'Strikethrough'
  | 'Share'
  | 'Settings'
  | 'Search'
  | 'Save'
  | 'Revert'
  | 'Restore'
  | 'Refresh'
  | 'Redo'
  | 'Publish'
  | 'PreviewImage'
  | 'Plus'
  | 'Pin'
  | 'PinFill'
  | 'Pen'
  | 'Paste'
  | 'Pages'
  | 'P'
  | 'NewFolder'
  | 'MoreVert'
  | 'Minus'
  | 'Menu'
  | 'Lock'
  | 'List'
  | 'ListNumbered'
  | 'ListChecked'
  | 'Link'
  | 'Launch'
  | 'Italic'
  | 'Info'
  | 'Images'
  | 'ImageSearch'
  | 'Home'
  | 'Hide'
  | 'H6'
  | 'H5'
  | 'H4'
  | 'H3'
  | 'H2'
  | 'H1'
  | 'Folder'
  | 'FindInPage'
  | 'FilterList'
  | 'FileUpload'
  | 'Expand'
  | 'Edit'
  | 'Duplicate'
  | 'Drag'
  | 'Drag1'
  | 'Draft'
  | 'DeviceX'
  | 'DeviceS'
  | 'DeviceM'
  | 'DeviceL'
  | 'Design'
  | 'Content'
  | 'ContentCopy'
  | 'Config'
  | 'Compress'
  | 'CommndCentre'
  | 'Close'
  | 'ClearFormat'
  | 'ChevronUp'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'ChevronDown'
  | 'Calendar'
  | 'Bold'
  | 'BindMirror'
  | 'Bin'
  | 'Audio'
  | 'ArrowUp'
  | 'ArrowRight'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'Alternate'
  | 'AlternateLink'
  | 'AddLayout'
  | 'AddAtBottom'
  | 'Pdf';

export enum IcmsIcons {
  Warning = 'warning',
  Vm = 'vm',
  View = 'view',
  Video = 'video',
  Unlink = 'unlink',
  Undo = 'undo',
  Underline = 'underline',
  Time = 'time',
  Tick = 'tick',
  Tag = 'tag',
  Style = 'style',
  Strikethrough = 'strikethrough',
  Share = 'share',
  Settings = 'settings',
  Search = 'search',
  Save = 'save',
  Revert = 'revert',
  Restore = 'restore',
  Refresh = 'refresh',
  Redo = 'redo',
  Publish = 'publish',
  PreviewImage = 'preview-image',
  Plus = 'plus',
  Pin = 'pin',
  PinFill = 'pin-fill',
  Pen = 'pen',
  Paste = 'paste',
  Pages = 'pages',
  P = 'p',
  NewFolder = 'new-folder',
  MoreVert = 'more-vert',
  Minus = 'minus',
  Menu = 'menu',
  Lock = 'lock',
  List = 'list',
  ListNumbered = 'list-numbered',
  ListChecked = 'list-checked',
  Link = 'link',
  Launch = 'launch',
  Italic = 'italic',
  Info = 'info',
  Images = 'images',
  ImageSearch = 'image-search',
  Home = 'home',
  Hide = 'hide',
  H6 = 'h6',
  H5 = 'h5',
  H4 = 'h4',
  H3 = 'h3',
  H2 = 'h2',
  H1 = 'h1',
  Folder = 'folder',
  FindInPage = 'find-in-page',
  FilterList = 'filter-list',
  FileUpload = 'file-upload',
  Expand = 'expand',
  Edit = 'edit',
  Duplicate = 'duplicate',
  Drag = 'drag',
  Drag1 = 'drag-1',
  Draft = 'draft',
  DeviceX = 'device-x',
  DeviceS = 'device-s',
  DeviceM = 'device-m',
  DeviceL = 'device-l',
  Design = 'design',
  Content = 'content',
  ContentCopy = 'content-copy',
  Config = 'config',
  Compress = 'compress',
  CommndCentre = 'commnd-centre',
  Close = 'close',
  ClearFormat = 'clear-format',
  ChevronUp = 'chevron-up',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  ChevronDown = 'chevron-down',
  Calendar = 'calendar',
  Bold = 'bold',
  BindMirror = 'bind-mirror',
  Bin = 'bin',
  Audio = 'audio',
  ArrowUp = 'arrow-up',
  ArrowRight = 'arrow-right',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  Alternate = 'alternate',
  AlternateLink = 'alternate-link',
  AddLayout = 'add-layout',
  AddAtBottom = 'add-at-bottom',
  Pdf = 'PDF',
}

export const ICMS_ICONS_CODEPOINTS: { [key in IcmsIcons]: string } = {
  [IcmsIcons.Warning]: '61697',
  [IcmsIcons.Vm]: '61698',
  [IcmsIcons.View]: '61699',
  [IcmsIcons.Video]: '61700',
  [IcmsIcons.Unlink]: '61701',
  [IcmsIcons.Undo]: '61702',
  [IcmsIcons.Underline]: '61703',
  [IcmsIcons.Time]: '61704',
  [IcmsIcons.Tick]: '61705',
  [IcmsIcons.Tag]: '61706',
  [IcmsIcons.Style]: '61707',
  [IcmsIcons.Strikethrough]: '61708',
  [IcmsIcons.Share]: '61709',
  [IcmsIcons.Settings]: '61710',
  [IcmsIcons.Search]: '61711',
  [IcmsIcons.Save]: '61712',
  [IcmsIcons.Revert]: '61713',
  [IcmsIcons.Restore]: '61714',
  [IcmsIcons.Refresh]: '61715',
  [IcmsIcons.Redo]: '61716',
  [IcmsIcons.Publish]: '61717',
  [IcmsIcons.PreviewImage]: '61718',
  [IcmsIcons.Plus]: '61719',
  [IcmsIcons.Pin]: '61720',
  [IcmsIcons.PinFill]: '61721',
  [IcmsIcons.Pen]: '61722',
  [IcmsIcons.Paste]: '61723',
  [IcmsIcons.Pages]: '61724',
  [IcmsIcons.P]: '61725',
  [IcmsIcons.NewFolder]: '61726',
  [IcmsIcons.MoreVert]: '61727',
  [IcmsIcons.Minus]: '61728',
  [IcmsIcons.Menu]: '61729',
  [IcmsIcons.Lock]: '61730',
  [IcmsIcons.List]: '61731',
  [IcmsIcons.ListNumbered]: '61732',
  [IcmsIcons.ListChecked]: '61733',
  [IcmsIcons.Link]: '61734',
  [IcmsIcons.Launch]: '61735',
  [IcmsIcons.Italic]: '61736',
  [IcmsIcons.Info]: '61737',
  [IcmsIcons.Images]: '61738',
  [IcmsIcons.ImageSearch]: '61739',
  [IcmsIcons.Home]: '61740',
  [IcmsIcons.Hide]: '61741',
  [IcmsIcons.H6]: '61742',
  [IcmsIcons.H5]: '61743',
  [IcmsIcons.H4]: '61744',
  [IcmsIcons.H3]: '61745',
  [IcmsIcons.H2]: '61746',
  [IcmsIcons.H1]: '61747',
  [IcmsIcons.Folder]: '61748',
  [IcmsIcons.FindInPage]: '61749',
  [IcmsIcons.FilterList]: '61750',
  [IcmsIcons.FileUpload]: '61751',
  [IcmsIcons.Expand]: '61752',
  [IcmsIcons.Edit]: '61753',
  [IcmsIcons.Duplicate]: '61754',
  [IcmsIcons.Drag]: '61755',
  [IcmsIcons.Drag1]: '61756',
  [IcmsIcons.Draft]: '61757',
  [IcmsIcons.DeviceX]: '61758',
  [IcmsIcons.DeviceS]: '61759',
  [IcmsIcons.DeviceM]: '61760',
  [IcmsIcons.DeviceL]: '61761',
  [IcmsIcons.Design]: '61762',
  [IcmsIcons.Content]: '61763',
  [IcmsIcons.ContentCopy]: '61764',
  [IcmsIcons.Config]: '61765',
  [IcmsIcons.Compress]: '61766',
  [IcmsIcons.CommndCentre]: '61767',
  [IcmsIcons.Close]: '61768',
  [IcmsIcons.ClearFormat]: '61769',
  [IcmsIcons.ChevronUp]: '61770',
  [IcmsIcons.ChevronRight]: '61771',
  [IcmsIcons.ChevronLeft]: '61772',
  [IcmsIcons.ChevronDown]: '61773',
  [IcmsIcons.Calendar]: '61774',
  [IcmsIcons.Bold]: '61775',
  [IcmsIcons.BindMirror]: '61776',
  [IcmsIcons.Bin]: '61777',
  [IcmsIcons.Audio]: '61778',
  [IcmsIcons.ArrowUp]: '61779',
  [IcmsIcons.ArrowRight]: '61780',
  [IcmsIcons.ArrowLeft]: '61781',
  [IcmsIcons.ArrowDown]: '61782',
  [IcmsIcons.Alternate]: '61783',
  [IcmsIcons.AlternateLink]: '61784',
  [IcmsIcons.AddLayout]: '61785',
  [IcmsIcons.AddAtBottom]: '61786',
  [IcmsIcons.Pdf]: '61787',
};
